import React from 'react';

const defaultContext = Object.freeze({});
export const SpringboardContext = React.createContext(defaultContext);
